module.exports = __webpack_public_path__ + "static/img/087_TO8_1742_og.5b2a15f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/087_TO8_1742_og.jpg
// module id = iq0X
// module chunks = 0